// Dati REALI XIV Memorial Eugenio Abbro 2026 - Primavera Cavese
// Fonte: brochure ufficiale XIV edizione + sito memorialeugenioabbro.it

export const siteInfo = {
  edition: "XIV Memorial",
  title: 'Eugenio Abbro',
  subtitle: 'di Calcio Giovanile',
  dateRange: '25 / 31 Maggio 2026',
  year: 2026,
  organization: 'A.S.D.P. Primavera Cavese',
  slogan: 'Sport, passione e crescita per i giovani di Cava de\' Tirreni',
  // Immagini generiche senza volti (pallone, campo, stadio)
  heroImage: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=1920&q=80',
  // Video di sfondo home — asset LOCALE (in /public) per evitare 404 da URL Emergent temporanei
  heroVideo: '/hero-video.mp4',
  // Video di presentazione della XIV edizione (banner video section) — asset LOCALE
  presentationVideo: '/presentation-video.mp4',
  // Logo Primavera Cavese — asset LOCALE
  logo: '/logo-primavera.png',
  // Brochure PDF — asset LOCALE
  brochurePdf: '/brochure-memorial-2026.pdf',
  // Immagine unica con tutti i patrocini — asset LOCALE
  patrocinImage: '/sponsors-patrocini.png',
  patrocinTitle: 'con il patrocinio di',
  patrocini: [
    { name: 'Consiglio Regionale della Campania', abbr: 'RC' },
    { name: 'Provincia di Salerno', abbr: 'PS' },
    { name: "Città di Cava de' Tirreni", abbr: 'CV' },
    { name: 'CONI Comitato Regionale Campania', abbr: 'CONI' },
  ],
};

export const contatti = {
  email: 'memorialeugenioabbro@gmail.com',
  phones: ['3898073799', '3282944811'],
  fax: '089349032',
  address: "Cava de' Tirreni (SA)",
  website: 'https://www.memorialeugenioabbro.it',
  facebook: 'https://www.facebook.com/61575893882491',
};

export const comitatoOrganizzatore = {
  presidenteOnorario: "Sig.ra Francesca Abbro",
  presidente: "Prof. Claudio Di Criscio",
  vicePresidente: "Daniele Tamigi",
  fotografoUfficiale: "Andrea Sorrentino",
  graficaImpaginazione: "Salvatore Lodato, Guerino Lodato",
  stampa: "TotalKlick",
};

export const chiSiamo = {
  title: 'Chi Siamo',
  subtitle: "A.S.D.P. Primavera Cavese",
  paragraphs: [
    "L'A.S.D.P. Primavera Cavese organizza dal 2005 il Memorial Calcistico Giovanile \"Eugenio Abbro\", nato in collaborazione con la Città di Cava de' Tirreni per onorare la figura di Eugenio Abbro, Sindaco per oltre 25 anni e instancabile promotore dello sport giovanile cavese.",
    "Giunto alla sua XIV edizione, il torneo coinvolge oltre 300 giovani calciatori appartenenti alle categorie Pulcini 2015, Pulcini 2016 e Primi Calci 2017/18, provenienti dalle squadre di Cava de' Tirreni e dell'intera provincia di Salerno.",
    "Il Memorial è un'iniziativa educativa e sociale: uno strumento che insegna ai più piccoli il rispetto delle regole, il valore del gioco di squadra, il fair play e la capacità di condividere emozioni e traguardi.",
  ],
  mission: [
    { icon: 'Trophy', title: 'Sport Giovanile', desc: "Valorizziamo i giovani calciatori del territorio." },
    { icon: 'Heart', title: 'Fair Play', desc: "Rispetto, lealtà e correttezza (Spirit of the Game)." },
    { icon: 'Users', title: 'Community', desc: "Oltre 300 ragazzi, famiglie e società sportive." },
    { icon: 'Award', title: 'Tradizione', desc: "14 edizioni dal 2005: un punto fermo del calcio cavese." },
  ],
};

// --- SQUADRE PARTECIPANTI XIV Memorial 2026 ---
// Ogni squadra ha: rosa giocatori, foto squadra (editabile dall'admin), sponsor squadra

const PLACEHOLDER_TEAM_PHOTO = 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=800&q=80';

export const squadrePulcini2015 = [
  { id: 1, name: "A.S.D. Pol. Rocchese", allenatori: "Amodio F., Liguori S. F., Polichetti F.", dirigente: "Liguori Simonfrancesco", girone: "A", color: '#16a34a',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Villa al Rifugio",
    giocatori: "Aliberti L., Astarita F., Catapano G., Dalla Ragione A., Ferrentino G. F., Ferrentino M., Izzo C., Salzano A., Senatore R., Stanzione D. P." },
  { id: 2, name: "A.S.D. Rinascita Cava 2000", allenatore: "Masullo Antonio", dirigente: "Milione Paolo", girone: "B", color: '#f59e0b',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "La Locanda del Popolo",
    giocatori: "Bisogno M., Aversa N., De Rosa M., Sorrentino G., D'Arco A., Carleo A., D'Arco G., Di Salvatore F., Manzo M., Giordano V., Bruno F. P., Iannone M., Lamberti E., Lamberti M., Picariello S." },
  { id: 3, name: "A.S.D. Diecipiù", allenatori: "Iannone Salvatore, Pagano Antonio", dirigente: "De Pascale Annibale", girone: "B", color: '#9333ea',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Revision & Service",
    giocatori: "Campone V., Russo G., Citarella C., Greco A., Lopetrone S., Pagano R., Pepe S., Senatore S. M., Vitolo G." },
  { id: 4, name: "A.S.D. RS3 Academy", allenatori: "Montanino M., Santoriello M., Apicella F.", dirigente: "Sergio Raffaele", girone: "B", color: '#0891b2',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "La.Sp.ed. Tirreno",
    giocatori: "Carleo M., Avagliano A., Senatore M., Senatore A., Senatore R., Mannara P., Grimaldi V., Murolo L., De Rosa D." },
  { id: 5, name: "A.S.D. Red Lions Piccolo Stadio", allenatore: "Bisogno Giovanni", dirigente: "Grottola Gerardo", girone: "A", color: '#dc2626',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Nola Ferrometalli Sud",
    giocatori: "Avella G., Ragone R., Di Agostino R., Molinaro M., Gambardella G., Giannatasio C., Albano A., Gente A., De Palma G., Della Corte S., Avagliano A., Adinolfi F." },
  { id: 6, name: "A.S.D. Montella Calcio", allenatore: "Mainardi Cosimo", dirigente: "Montella Cosimo", girone: "A", color: '#1e40af',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Arredamenti Paoletti",
    giocatori: "Mainardi P., Longombardi L., Giordano A., D'Antuono M., Attianese A., Barba S., Marrazzo A., Battipaglia M., Trapani V., Greco A., Villani S." },
  { id: 7, name: "A.S.D. Aquilotti Cavesi", allenatore: "Avagliano Giovanni", dirigente: "Siani Biagio", girone: "A", color: '#0369a1',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Cicalese Interni",
    giocatori: "Adinolfi S., Adamo A., Apicella M., Bianco G., D'Elia P., Di Domenico A., Errico E., Ferrara A., Gallo J., Gigantino E., Lamberti G., Massa F., Meuti C., Nocera A., Senatore E., Siani G., Sorrentino C., Strazzullo L., Tramontano G. A., Fioraso S., Vitale P., Vitale F., Bisogno R., Iovine A., Afeltra M., De Rosa A." },
  { id: 8, name: "A.S.D. Olimpia Sport", allenatore: "Giaquinto Filippo", dirigente: "D'Acunto Antonio", girone: "B", color: '#ea580c',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Olimpia Sport Cava",
    giocatori: "Baldi C., Benevento R., Califano C., Fierro F., Iannone A., Mercurio S., Marrafino G., Palumbo G., Santulli A., Scafuri M." },
];

export const squadrePulcini2016 = [
  { id: 1, name: "A.S.D. Azzurra Fatima FBC", allenatore: "Giordano Gerardo", dirigente: "Vitiello Ciro", girone: "A", color: '#0284c7',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "FM Cellular",
    giocatori: "Pepe J., Vitale F., Veneziano G., Schiavo G., Gravino V., Schiavo S., Carrelli C., Pentangelo F., Renzulli D., Adallal A., Pepe A., Buonocore D., Marrazzo A., Russo G., Verdoliva V." },
  { id: 2, name: "A.S.D. Rinascita Cava 2000", allenatore: "Cardella Marco", dirigente: "Senatore Luca", girone: "A", color: '#f59e0b',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Eugenio Violante",
    giocatori: "Angrisani R., Bisogno Michele, Bisogno Manuela, Adinolfi L., Bisogno Francesco, Trapanese T., Carotenuto S., Armenante G., Polverino G." },
  { id: 3, name: "A.S.D. Primavera Cavese", allenatore: "Senatore Luca", dirigente: "Cardella Marco", girone: "A", color: '#1e3a8a',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "A.S.D.P. Primavera Cavese",
    giocatori: "D'Arco G., Della Rocca C., Farkaj L., Lodato M., Palma A., Spirito A., Cantini F., Di Domenico A., Di Filippo G., Di Martino G., Celano L., Bombardo F." },
  { id: 4, name: "A.S.D. R. Sergio Academy", allenatori: "Montanino M., Santoriello M., Apicella F.", dirigente: "Sergio Raffaele", girone: "B", color: '#0891b2',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Dream in Tavula",
    giocatori: "D'Ambrosio M., Coda A., Monetta M., Fariello E., Apicella V., Della Corte C., Avella G., Corrias G., Malafronte F., Ronca G." },
  { id: 5, name: "A.S.D. Red Lions Piccolo Stadio", allenatore: "Di Lieto Massimo", dirigente: "Grottola Gerardo", girone: "B", color: '#dc2626',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Trasporto Rifiuti I.F.M.",
    giocatori: "Baldi J., Moccia M., Cesaro I., Maiorano J., Massa F., Ragone C., Spera P., Senatore S., Cirone V., Giordano A., Covone L., Lambiase L., Echagal A." },
  { id: 6, name: "A.S.D. Diecipiù", allenatori: "Pastore P., Pinto G., Rossi F.", dirigente: "Rito Marcone Giacomo", girone: "B", color: '#9333ea',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "De Clemente Pomodori",
    giocatori: "Barbato M., Bisogno D. G., Casillo C., Fezza R., Lambiase A. A., Marchese J., Senatore A., Scarpa V., Salzano M." },
  { id: 7, name: "A.S.D. Aquilotti Cavesi", allenatore: "Gatto Pietro", dirigente: "Siani Biagio", girone: "B", color: '#0369a1',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Cardamone Massimo",
    giocatori: "Apicella M., Baldi A., Cardamone A., Conza P., Lamberti L., Lamberti A. M., Maddalo F., Maddalo G., Mannara D., Palladino L., Palombo M., Pignatiello D., Salsano M., Salsano S., Sansone R., Siani A., Sorrentino G., Sorrentino L., Trezza B., Visone R., Pietrobono G., Angrisani F., Milito M., Morea F., Senatore S., Medolla V." },
  { id: 8, name: "A.S.D. Olimpia Sport", allenatore: "Giaquinto Filippo", dirigente: "D'Acunto Antonio", girone: "A", color: '#ea580c',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Farmacia Accarino",
    giocatori: "Aquino F., Nola G., Baselice M., Chierchia L., Petrosino L., Barba V., Annunziata F., Quaranta G., Manzione G., Blasio E., Capuano L., De Vivo F." },
];

export const squadrePrimiCalci = [
  { id: 1, name: "A.S.D. Diecipiù", allenatori: "Rito Marcone Stefano, Sammartino Antonio", dirigente: "Cicalese Gennaro", girone: "A", color: '#9333ea',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Maidan Caffetteria",
    giocatori: "Balan D., Di Benedetto V., Di Luggo Arcangelo P., Greco A., Manfredini L., Mercadante Alfredo S., Puopolo S., Savastano F., Sessa Antonio C." },
  { id: 2, name: "A.S.D. Rinascita Cava 2000", allenatore: "Della Monica Carmela", dirigente: "Petti Vincenzo", girone: "B", color: '#f59e0b',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Parco degli Ulivi",
    giocatori: "Della Corte M., Galdi A., Della Corte V., Senatore S., Adinolfi A., Maiorano G., Nizza M., Di Salvo A., Pannullo V., Faiella R." },
  { id: 3, name: "A.S.D. Primavera Cavese", allenatore: "Petti Vincenzo", dirigente: "Della Monica Carmela", girone: "B", color: '#1e3a8a',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Elettrica Vitale",
    giocatori: "Santangelo N., Trapanese C., Ferrara M., Di Mauro N., Padovano A., Barella S., Siani L., Avallone G., Cardamone G." },
  { id: 4, name: "A.S.D. R. Sergio Academy", allenatori: "Montanino M., Santoriello M., Apicella F., Monetta R.", dirigente: "Sergio Raffaele", girone: "A", color: '#0891b2',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Senatore Impianti",
    giocatori: "Senatore G., Apicella G., Pezzano M., Avagliano E., Danise P., Senatore L., Della Brenda M., Paglietta M., De Luca G., D'Amico C., Vigorito C., Pagliuca G." },
  { id: 5, name: "A.S.D. Red Lions Piccolo Stadio", allenatore: "-", dirigente: "Villari Giovanni (338 3176026)", girone: "A", color: '#dc2626',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Residencia Barrio",
    giocatori: "Sangiovanni A., Trapanese G., Senatore A., Capriglione F., Alfieri A., Piscino G., Senatore S., Mastrangelo F., Massimino F., D'Elia S., Picariello I., Falcone M." },
  { id: 6, name: "A.S.D. Olimpia Sport", allenatore: "Senatore Matteo", dirigente: "D'Acunto Antonio", girone: "B", color: '#ea580c',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Clinica Tirrena",
    giocatori: "Salvati A., Faiella G., Vitiello S., D'Acunto P., Fabbricatore A., Della Mura M., Stoian D., Ferraioli L., Vicidomini A." },
  { id: 7, name: "A.S.D. Aquilotti Cavesi", allenatore: "Gatto Pietro", dirigente: "Avagliano Giovanni", girone: "B", color: '#0369a1',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Pizza Mamma Lucia",
    giocatori: "Adinolfi S., Altobello A., Avagliano A., Bisogno F., Capece G., Capuano R., Cardamone M., Coppola V., D'Andria N. A., De Sio F., Desiderio Vigorito B., Di Domenico P., Di Lieto R., Maresca Pasquale S. L., Masullo A., Pergola L., Ronca S., Rumolo V., Santucci M., Senatore A., Siani V., Vicidomini F., Vitale Lorenzo F., Della Monica A., Di Domenico G., Lambiase J., Rispoli G., Canora B., Senatore A." },
  { id: 8, name: "A.S.D. Montella Calcio", allenatore: "Montella Giuseppe", dirigente: "Vatiero Alessandro", girone: "A", color: '#1e40af',
    foto: PLACEHOLDER_TEAM_PHOTO, sponsor: "Funghi & Surgelati",
    giocatori: "Fiocco A., Fiocco A., Montella G., Vatiero A., Iannone P., Montella C., Fiumara P., Mercurio M., Sanelli M., Paganini R., Botta L., Attianese G., Ferraioli G., Desiderio R., Rosato G., Longobardi G., Limodio A., Tedesco F., Cirillo F." },
];

// Categorie meta
export const categorie = [
  { key: 'pulcini-2015', label: 'Pulcini 2015', squadre: squadrePulcini2015, colorAccent: '#36a9e1' },
  { key: 'pulcini-2016', label: 'Pulcini 2016', squadre: squadrePulcini2016, colorAccent: '#0891b2' },
  { key: 'primi-calci', label: 'Primi Calci 2017/18', squadre: squadrePrimiCalci, colorAccent: '#16a34a' },
];

// --- CLASSIFICHE (da aggiornare quando disponibili) ---
export const classifiche = {
  'pulcini-2015': {
    categoria: 'Pulcini 2015',
    status: 'In attesa',
    finale: 'Domenica 31 Maggio 2026 · Stadio S. Lamberti · ore 19:30',
    ranking: [],
    premi: [
      { label: 'Fair Play', team: 'Da assegnare' },
      { label: 'Miglior Portiere', team: 'Da assegnare' },
      { label: 'Capocannoniere', team: 'Da assegnare' },
    ],
  },
  'pulcini-2016': {
    categoria: 'Pulcini 2016',
    status: 'In attesa',
    finale: 'Domenica 31 Maggio 2026 · Stadio S. Lamberti · ore 18:30',
    ranking: [],
    premi: [
      { label: 'Fair Play', team: 'Da assegnare' },
      { label: 'Miglior Portiere', team: 'Da assegnare' },
      { label: 'Capocannoniere', team: 'Da assegnare' },
    ],
  },
  'primi-calci': {
    categoria: 'Primi Calci 2017/18',
    status: 'In attesa',
    finale: 'Domenica 31 Maggio 2026 · Stadio S. Lamberti · ore 17:30',
    ranking: [],
    premi: [
      { label: 'Fair Play', team: 'Da assegnare' },
      { label: 'Miglior Portiere', team: 'Da assegnare' },
      { label: 'Capocannoniere', team: 'Da assegnare' },
    ],
  },
};

// --- CAMPI DA GIOCO 2026 ---
export const campiDaGioco = [
  { id: 1, nome: 'Mini Calcio Piccolo Stadio', indirizzo: "Cava de' Tirreni", tipo: 'Campo gare' },
  { id: 2, nome: 'Mini Calcio R. Sergio Academy', indirizzo: "Cava de' Tirreni", tipo: 'Campo gare' },
  { id: 3, nome: 'Mini Calcio Passiano', indirizzo: "Via A. Ferrigno, 7 · Passiano", tipo: 'Campo gare' },
  { id: 4, nome: 'Mini Calcio Citola', indirizzo: "Cava de' Tirreni", tipo: 'Campo gare' },
  { id: 5, nome: 'Stadio Comunale Simonetta Lamberti', indirizzo: "Cava de' Tirreni", tipo: 'Finali' },
];

export const finaleInfo = {
  data: '31 Maggio 2026',
  giorno: 'Domenica',
  stadio: 'Stadio Comunale Simonetta Lamberti',
  indirizzo: "Cava de' Tirreni (SA)",
  programma: [
    { ora: '17:30', evento: 'Finale XIV Memorial "Eugenio Abbro" · Categoria Primi Calci 2017/18' },
    { ora: '18:30', evento: 'Finale XIV Memorial "Eugenio Abbro" · Categoria Pulcini 2016' },
    { ora: '19:30', evento: 'Finale XIV Memorial "Eugenio Abbro" · Categoria Pulcini 2015' },
    { ora: '20:30', evento: 'Cerimonia di Premiazione · Esibizione Archibugieri Cavalieri Bolla Pontificia A.D. 1394' },
    { ora: '21:30', evento: 'Grande Spettacolo Piromusicale "Accendi un Evento" (fuochi e musica sincronizzata)' },
    { ora: '20:30', evento: 'Premiazione Concorso di Disegno I.C. S. Lucia · 1ª edizione' },
  ],
};

// --- CALENDARIO GARE ---
export const calendario = [
  {
    data: 'Lunedì 25 Maggio 2026', giorno: 'Lunedì', eventi: [
      { ora: '16:00', evento: 'Pulcini 2016 · Red Lions vs Rinascita Cava 2000 · Girone A', luogo: 'Campo Piccolo Stadio' },
      { ora: '17:00', evento: 'Primi Calci 2017/18 · Aquilotti Cavesi · 1ª Giornata', luogo: 'Mini Calcio Piccolo Stadio' },
    ]
  },
  {
    data: 'Martedì 26 Maggio 2026', giorno: 'Martedì', eventi: [
      { ora: '15:15', evento: 'Pulcini 2016 · Olimpia Sport · 2ª Giornata', luogo: 'Campo R. Sergio' },
      { ora: '16:15', evento: 'Pulcini 2015 · Diecipiù · 1ª Giornata', luogo: 'Campo R. Sergio' },
      { ora: '17:15', evento: 'Primi Calci 2017/18 · Aquilotti Cavesi · 2ª Giornata', luogo: 'Campo R. Sergio' },
    ]
  },
  {
    data: 'Mercoledì 27 Maggio 2026', giorno: 'Mercoledì', eventi: [
      { ora: '15:15', evento: 'Pulcini 2015 · Olimpia Sport · Girone A', luogo: 'Campo Citola' },
      { ora: '15:15', evento: 'Pulcini 2016 · RS3 Academy · Girone B', luogo: 'Campo R. Sergio' },
      { ora: '15:15', evento: 'Primi Calci · Diecipiù · Girone A', luogo: 'Mini Calcio Passiano' },
      { ora: '16:15', evento: 'Primi Calci · Red Lions · Girone A', luogo: 'Mini Calcio Passiano' },
      { ora: '17:15', evento: 'Pulcini 2015 · Red Lions vs Pol. Rocchese · Girone A', luogo: 'Campo Citola' },
      { ora: '17:15', evento: 'Pulcini 2016 · Olimpia Sport · Girone A', luogo: 'Campo Piccolo Stadio' },
      { ora: '17:15', evento: 'Primi Calci · Primavera Cavese · Girone B', luogo: 'Campo R. Sergio' },
    ]
  },
  {
    data: 'Giovedì 28 Maggio 2026', giorno: 'Giovedì', eventi: [
      { ora: '15:15', evento: 'Pulcini 2015 · Aquilotti Cavesi · 3ª Giornata', luogo: 'Campo Citola' },
      { ora: '15:15', evento: 'Pulcini 2016 · Rinascita Cava 2000 vs Azzurra Fatima · 3ª Giornata', luogo: 'Campo Piccolo Stadio' },
      { ora: '15:15', evento: 'Primi Calci · Diecipiù vs Primavera Cavese · 3ª Giornata', luogo: 'Mini Calcio Passiano' },
      { ora: '16:15', evento: 'Pulcini 2015 · RS3 Academy vs Olimpia Sport · Girone B', luogo: 'Campo R. Sergio' },
      { ora: '17:15', evento: 'Pulcini 2015 · Olimpia Sport · 3ª Giornata', luogo: 'Campo Citola' },
      { ora: '17:15', evento: 'Pulcini 2016 · RS3 Academy vs Olimpia Sport · 3ª Giornata', luogo: 'Campo R. Sergio' },
      { ora: '17:15', evento: 'Primi Calci · 3ª Giornata Girone A/B', luogo: 'Campo R. Sergio · Passiano' },
    ]
  },
  {
    data: 'Venerdì 29 Maggio 2026', giorno: 'Venerdì', eventi: [
      { ora: '16:15', evento: 'SEMIFINALE · 1° Girone A vs 2° Girone B', luogo: 'Mini Calcio Citola · Passiano' },
      { ora: '17:15', evento: 'SEMIFINALE · 1° Girone B vs 2° Girone A', luogo: 'Mini Calcio Citola · Passiano' },
    ]
  },
  {
    data: 'Sabato 30 Maggio 2026', giorno: 'Sabato', eventi: [
      { ora: '—', evento: 'Giornata di riposo / preparazione finali', luogo: 'Cava de\' Tirreni' },
    ]
  },
  {
    data: 'Domenica 31 Maggio 2026', giorno: 'Domenica', eventi: [
      { ora: '17:30', evento: 'FINALE Primi Calci 2017/18', luogo: 'Stadio S. Lamberti' },
      { ora: '18:30', evento: 'FINALE Pulcini 2016', luogo: 'Stadio S. Lamberti' },
      { ora: '19:30', evento: 'FINALE Pulcini 2015', luogo: 'Stadio S. Lamberti' },
      { ora: '20:30', evento: 'Cerimonia di Premiazione · Esibizione Archibugieri Cavalieri Bolla Pontificia A.D. 1394', luogo: 'Stadio S. Lamberti' },
      { ora: '21:30', evento: 'Spettacolo Piromusicale "Accendi un Evento"', luogo: 'Stadio S. Lamberti' },
    ]
  },
];

// --- REGOLAMENTO ---
export const regolamento = [
  { titolo: "Art. 1 — Organizzazione", testo: "La società A.S.D.P. Primavera Cavese, in collaborazione con il Comitato Promotore E. Abbro, indice ed organizza il XIV Memorial E. Abbro, che si svolgerà dal 25/05 al 31/05/2026 presso gli impianti sportivi di Cava de' Tirreni: Mini Calcio Piccolo Stadio, Mini Calcio R. Sergio, Mini Calcio Passiano e Mini Calcio Citola, con finale allo Stadio Comunale Simonetta Lamberti." },
  { titolo: "Art. 2 — Categorie Pulcini 2015 / Pulcini 2016 / Primi Calci 2017-18", testo: "Il Memorial è riservato ai calciatori appartenenti alle categorie Pulcini (2015), Pulcini (2016) e Primi Calci (2017/18), regolarmente tesserati con la propria società e federazione per la stagione 2025/2026. Le società partecipanti dovranno presentare l'elenco dei giocatori (massimo 12) prima dell'inizio del torneo. Dopo la consegna non sono consentite modifiche (salvo infortuni documentati). È obbligatorio presentare all'arbitro carta d'identità, cartellino federale o tessera ente di promozione con tabulato." },
  { titolo: "Art. 3 — Prestiti", testo: "Non sono consentiti prestiti tra società." },
  { titolo: "Art. 4 — Società partecipanti", testo: "Al Memorial parteciperanno 8 società per ciascuna categoria. L'iscrizione è gratuita. L'attività Pulcini e Primi Calci ha carattere promozionale, ludico e didattico: gli organizzatori confidano nella lealtà e correttezza di ogni atleta, nel rispetto dello Spirit of the Game (SOTG)." },
  { titolo: "Art. 5 — Formula del Memorial", testo: "Si svolgerà con 2 gironi da 4 squadre per ogni categoria che si incontreranno con gare di sola andata. Le prime due classificate di ciascun girone disputeranno semifinali e finale." },
  { titolo: "Art. 6 — Classifiche", testo: "Vittoria 3 punti · Pareggio 1 punto · Sconfitta 0 punti. In caso di parità: scontri diretti, differenza reti nel girone, maggior numero di reti segnate, minor numero di reti subite, sorteggio. In caso di parità nelle semifinali/finale: calci di rigore (3 a testa + oltranza, compreso il portiere). La rete prima del centrocampo è valida solo se toccata da calciatore/portiere/palo/traversa." },
  { titolo: "Art. 7 — Tempi di gara", testo: "Le gare si svolgeranno in due tempi da 20 minuti ciascuno. Le partite si giocano 7 contro 7 per tutte le categorie su campi di dimensioni ridotte. Una squadra che si presenta con oltre 20 minuti di ritardo avrà partita persa 3-0 (i goal non vengono conteggiati in classifica)." },
  { titolo: "Art. 8 — Reclami", testo: "È possibile inoltrare reclamo all'organizzazione entro 20 minuti dal termine della gara, versando una quota di 100€. Copia del reclamo deve essere consegnata alla controparte entro i 20 minuti." },
  { titolo: "Art. 9 — Assicurazioni", testo: "Ogni società partecipante è responsabile della copertura assicurativa dei propri tesserati." },
];

// --- SPONSORS / PARTNER ---
// Sistema flessibile a sezioni: ogni sezione ha un titolo + modalità:
//   - 'image': una singola PNG trasparente con tutti i loghi già impaginati
//   - 'grid' : griglia di loghi singoli (editabili)
export const partnerSections = [
  {
    id: 'main',
    titolo: 'Main Partners',
    sottotitolo: 'I partner principali del XIV Memorial',
    modalita: 'grid', // 'image' o 'grid'
    immagine: null, // Se modalita='image', URL della PNG trasparente
    items: [
      { id: 1, name: "D'Agostino Costruzioni Generali", tagline: 'Main Partner', color: '#0891b2', logo: null },
      { id: 2, name: 'Gruppo Milito', tagline: 'Movimenti terra · Urbanizzazione', color: '#b45309', logo: null },
      { id: 3, name: 'TrediImpresit', tagline: 'Costruzioni edili', color: '#dc2626', logo: null },
    ],
  },
  {
    id: 'partner-ufficiali',
    titolo: 'Partner Ufficiali',
    sottotitolo: 'Le realtà che sostengono l\'evento',
    modalita: 'grid',
    immagine: null,
    items: [
      { id: 4, name: 'LithoPlus', tagline: 'Stampa · Creatività', color: '#06b6d4', logo: null },
      { id: 5, name: 'TotalKlick', tagline: 'Web Agency', color: '#36a9e1', logo: null },
      { id: 6, name: 'FlessoFab', tagline: 'Montemiletto (AV)', color: '#059669', logo: null },
      { id: 7, name: 'Lamberti Petroli', tagline: 'Energia', color: '#f59e0b', logo: null },
      { id: 8, name: 'E.RI. / TE.RI.', tagline: 'Riabilitazione', color: '#0284c7', logo: null },
      { id: 9, name: 'Raffatherm', tagline: 'Impianti idraulici · Gas', color: '#b91c1c', logo: null },
      { id: 10, name: 'De Clemente', tagline: 'Pomodori 100% Italiano', color: '#15803d', logo: null },
      { id: 11, name: 'MF Ecology', tagline: 'Consulenza ambientale', color: '#065f46', logo: null },
      { id: 12, name: 'Restyling Car', tagline: 'Carrozzeria · Meccanica', color: '#7c2d12', logo: null },
      { id: 13, name: 'P.T. Gomme Firststop', tagline: 'Assistenza Auto', color: '#1f2937', logo: null },
      { id: 14, name: 'Albrico', tagline: 'Aria di Primavera', color: '#be185d', logo: null },
      { id: 15, name: 'Farmacia Accarino', tagline: 'Servizi in Farmacia', color: '#16a34a', logo: null },
      { id: 16, name: 'Olimpia Sport', tagline: 'Scuola nuoto', color: '#0369a1', logo: null },
      { id: 17, name: 'Villa al Rifugio', tagline: 'Cava de\' Tirreni', color: '#7c3aed', logo: null },
      { id: 18, name: 'Ceramica La Vietrese', tagline: 'Manifattura artistica', color: '#ea580c', logo: null },
    ],
  },
];

// Compat: vecchio export "sponsors" per HomePage e Chi Siamo
export const sponsors = partnerSections.flatMap((s) =>
  s.items.map((it) => ({ ...it, tier: s.id === 'main' ? 'main' : 'partner' }))
);

// Brochure Images (mostra copertina + pagine brochure)
export const brochurePages = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  image: [
    'https://images.unsplash.com/photo-1598880513655-d1c6d4b2dfbf?w=600',
    'https://images.unsplash.com/photo-1600077063877-22118d6290eb?w=600',
    'https://images.unsplash.com/photo-1622659097509-4d56de14539e?w=600',
    'https://images.unsplash.com/photo-1622659097972-68f1d8c1829f?w=600',
    'https://images.unsplash.com/photo-1602432141202-e8b683524997?w=600',
    'https://images.pexels.com/photos/33210166/pexels-photo-33210166.jpeg?w=600',
    'https://images.unsplash.com/flagged/photo-1568127539877-487e4825ec58?w=600',
    'https://images.unsplash.com/photo-1622659099549-5eda1203b849?w=600',
  ][i % 8],
  title: `Pagina ${i + 1}`,
}));

export const videoHighlights = [
  {
    id: 1,
    title: 'XIV Memorial Eugenio Abbro 2026 · Presentazione',
    description: 'Il video ufficiale di presentazione della XIV edizione · 25-31 Maggio 2026',
    thumbnail: 'https://images.unsplash.com/photo-1598880513655-d1c6d4b2dfbf?w=800',
    videoUrl: '/presentation-video.mp4',
    type: 'video',
  },
  {
    id: 2,
    title: 'XIII Memorial 2025 · Esibizione Archibugieri',
    description: 'Cavalieri Bolla Pontificia A.D. 1394 · Apertura serata finale 2025',
    thumbnail: 'https://images.unsplash.com/photo-1600077063877-22118d6290eb?w=800',
    facebookUrl: 'https://www.facebook.com/61575893882491/videos/1072885967592709/',
    type: 'facebook',
  },
  {
    id: 3,
    title: 'XIII Memorial 2025 · Premiazione',
    description: "Cerimonia di chiusura 01/06/2025 · Stadio S. Lamberti",
    thumbnail: 'https://images.unsplash.com/photo-1622659099549-5eda1203b849?w=800',
    facebookUrl: 'https://www.facebook.com/61575893882491/videos/1682781555675932/',
    type: 'facebook',
  },
];

// --- CONCORSO DI DISEGNO 2026 ---
export const concorsoDisegno = {
  titolo: "1ª Edizione Concorso di Disegno",
  descrizione: "Il Comitato \"Eugenio Abbro\" e l'A.S.D. Primavera Cavese, in collaborazione con l'I.C. S. Lucia di Cava de' Tirreni, presentano la 1ª edizione del Concorso di Disegno.",
  premiazione: "Domenica 31 Maggio 2026 · ore 20:30 · Stadio Comunale S. Lamberti",
  dettagli: "Verrà premiato il miglior disegno di ogni gruppo di classi durante la cerimonia di chiusura del Memorial \"Eugenio Abbro\" di Calcio Giovanile.",
};

// --- EDIZIONI PASSATE (archivio) ---
// Copertine generiche senza volti
export const edizioniPassate = [
  {
    anno: 2025,
    edizione: 'XIII Memorial Eugenio Abbro',
    date: '27 Maggio - 1 Giugno 2025',
    vincitoriCategorie: [
      { categoria: 'Primi Calci 2016/17', vincitore: 'A.S.D. Olimpia Sport' },
      { categoria: 'Pulcini 2014/15', vincitore: 'A.S.D. Juve Stabia Academy' },
    ],
    squadrePartecipanti: 18,
    copertina: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=1600&q=80',
    descrizione: "Edizione 2025 con esibizione degli Archibugieri, spettacolo pirotecnico e saluto dal Gambia. Due categorie, 18 squadre coinvolte.",
    highlights: [
      'Esibizione Archibugieri Cavalieri Bolla Pontificia A.D. 1394',
      'Spettacolo pirotecnico di M. & G. Buonfiglio — "Accendi un Evento"',
      'Saluto dei partecipanti dal Gambia',
    ],
  },
  {
    anno: 2024,
    edizione: 'XII Memorial Eugenio Abbro',
    date: '28 Maggio - 2 Giugno 2024',
    vincitoriCategorie: [
      { categoria: 'Primi Calci', vincitore: 'Da archivio' },
      { categoria: 'Pulcini', vincitore: 'Da archivio' },
    ],
    squadrePartecipanti: 14,
    copertina: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?w=1600&q=80',
    descrizione: 'Edizione XII con grande partecipazione di squadre locali e provinciali.',
    highlights: [],
  },
  {
    anno: 2023,
    edizione: 'XI Memorial Eugenio Abbro',
    date: '29 Maggio - 3 Giugno 2023',
    vincitoriCategorie: [
      { categoria: 'Primi Calci', vincitore: 'Da archivio' },
      { categoria: 'Pulcini', vincitore: 'Da archivio' },
    ],
    squadrePartecipanti: 12,
    copertina: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1600&q=80',
    descrizione: "Undicesima edizione dedicata alla crescita dei giovani calciatori cavesi.",
    highlights: [],
  },
];

// --- GALLERIA FOTO (popolabile dall'admin) ---
// Placeholder: immagini generiche senza volti
export const galleriaFoto = [
  { id: 1, src: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=900&q=80', titolo: 'Il campo di gioco', categoria: 'Serata finale', data: '2025' },
  { id: 2, src: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?w=900&q=80', titolo: 'Pallone ai piedi', categoria: 'Partite', data: '2025' },
  { id: 3, src: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=900&q=80', titolo: 'Pronti al calcio', categoria: 'Partite', data: '2025' },
  { id: 4, src: 'https://images.unsplash.com/photo-1600077063877-22118d6290eb?w=900&q=80', titolo: 'Atmosfera dello stadio', categoria: 'Serata finale', data: '2025' },
  { id: 5, src: 'https://images.unsplash.com/photo-1602432141202-e8b683524997?w=900&q=80', titolo: 'Rete del goal', categoria: 'Partite', data: '2025' },
  { id: 6, src: 'https://images.pexels.com/photos/33210166/pexels-photo-33210166.jpeg?w=900', titolo: 'Vista aerea del campo', categoria: 'Campi', data: '2025' },
];

// --- VIDEO (popolabile dall'admin) ---
export const galleriaVideo = [
  {
    id: 1,
    titolo: 'XIV Memorial 2026 · Presentazione',
    descrizione: 'Video ufficiale di presentazione della XIV edizione',
    thumbnail: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=800',
    videoUrl: '/presentation-video.mp4',
    tipo: 'video',
    anno: 2026,
  },
];

// Credenziali di accesso (demo frontend - da sostituire con backend)
// Admin principale = gestisce tutto
// Organizzazione = accesso esclusivo solo a Classifiche & Risultati
export const adminCredentials = {
  admin: { username: 'admin', password: 'admin123', role: 'admin', label: 'Amministratore' },
  organizzazione: { username: 'organizzazione', password: 'memorial2026', role: 'organizzazione', label: 'Organizzazione (solo risultati)' },
};

// --- RINGRAZIAMENTI (dalla brochure) ---
export const ringraziamenti = {
  autorita: [
    "Famiglia Abbro",
    "Famiglia Aliberti",
    "Famiglia Lamberti",
    "Famiglia De Santis",
    "Giuseppe Fabbricatore - Consigliere Regionale",
    "Giovanni Guzzo - Presidente F.F. Provincia di Salerno",
    "Vincenzo Servalli - Sindaco di Cava de' Tirreni",
    "Annamaria Altobello - Assessore allo Sport",
    "Sergio Roncelli - Presidente Comitato Regionale C.O.N.I. Campania",
    "Gabriella Liberti - Dirigente Ist. Comprensivo S. Lucia",
    "Alessandro Lamberti - Presidente Cavese 1919",
    "Antonio D'Agostino - Presidente U.S. Avellino Calcio 1912",
    "Antonio Caserta - Presidente Consorzio per il Mezzogiorno",
    "Raffaele De Clemente - Presidente A.S.D. Sanseverinese",
  ],
  partner: [
    "Giuseppe Milito — Gruppo Milito",
    "Francesco Fabbricatore — FlessoFab",
    "Luigi Lamberti — Lamberti Petroli",
    "Biagio Manzo — LithoPlus",
    "Andrea Sorrentino — TotalKlick srls",
  ],
  operativi: [
    "Croce Rossa Sez. Cava de' Tirreni",
    "Gerardo Baldi",
    "Mini calcio Passiano",
    "Mini calcio Piccolo Stadio",
    "Mini calcio R. Sergio Academy",
    "Mini calcio Citola",
    "Nicola Carusone", "José Sorrentino", "Andrea Salsano",
    "Michele Memoli", "Raffaele Scarano",
  ],
};
